import React from 'react';
import datasetParser from "@Dataset/datasetParser";
import Tooltip from "@Popover/components/Tooltip";
import DepartureStationPopoverOverlay
    from "@Pages/stationToStation/features/departureStationPopover/components/DepartureStationPopoverOverlay";
import DepartureStationPopoverTrigger
    from "@Pages/stationToStation/features/departureStationPopover/components/DepartureStationPopoverTrigger";

interface DepartureStationPopoverProps {
    departureTime?: string,
    departureStation?: string,
    routeId?: string,
    index?: number,
}

function DepartureStationPopover(props: DepartureStationPopoverProps) {
    const {
        departureTime: departureTimeProps = null,
        departureStation: departureStationProps = null,
        routeId: routeIdProps = null,
        index,
    } = props

    const parsedData = !routeIdProps ? datasetParser({className: 'gb--departure', index}) : null
    const departureTime = departureTimeProps ?? parsedData?.time
    const departureStation = departureStationProps ?? parsedData?.name
    const routeId = routeIdProps ?? parsedData?.id

    return (
        <>
            <Tooltip
                tooltipContent={(
                    <DepartureStationPopoverOverlay
                        departureStation={departureStation}
                        routeId={routeId}
                    />
                )}
                className="gb--route-time"
            >
                <DepartureStationPopoverTrigger
                    departureTime={departureTime}
                />
            </Tooltip>
            <span className="gb--truncate">
                {departureStation}
            </span>
        </>
    );
}

export default DepartureStationPopover;